module.exports = __webpack_public_path__ + "static/media/1_r_stolb_92.03_46.85.baf77097.png";